import type { FbsDecision } from '../types/FbsDecision';
import { formatCurrency } from './formatters';

export const getTermLength = (fbsDecision?: FbsDecision) => {
  return fbsDecision?.terms?.[0]?.length;
};

export const getMinApr = (fbsDecision?: FbsDecision) => {
  return fbsDecision?.terms?.[0]?.minTermRate.apr || 0;
};

export const getMaxApr = (fbsDecision?: FbsDecision) => {
  return fbsDecision?.terms?.[0]?.maxTermRate.apr || 0;
};

export const getMinPayment = (fbsDecision?: FbsDecision) => {
  if (fbsDecision?.terms?.[0]) {
    return formatCurrency(
      fbsDecision?.terms?.[0]?.minTermRate?.monthlyPayment || 0,
    );
  }
  return 0;
};

export const getMaxPayment = (fbsDecision?: FbsDecision) => {
  if (fbsDecision?.terms?.[0]) {
    return formatCurrency(
      fbsDecision?.terms?.[0]?.maxTermRate?.monthlyPayment || 0,
    );
  }
  return 0;
};
